import { useEffect, useState } from "react";
import { IStoredSetting } from "@store/me/actionTypes";
import { useMe } from "@utils/hooks/useMe";
import { IPoolSelectorProps } from "./PoolSelector.props";
import { useFirstRender } from "@utils/hooks/useFirstRender";

export const usePoolSelectorControl = (props: IPoolSelectorProps) => {
  const { oldValue, currentValue, getPoolValue } = props;
  const firstRender = useFirstRender();
  const me = useMe();
  const [prevValue] = useState<IStoredSetting | undefined>(oldValue);
  const [value, setValue] = useState<IStoredSetting | undefined>(
    currentValue || oldValue
  );
  const [initialValue] = useState<IStoredSetting | undefined>(value);

  const onSelect = (option: IStoredSetting) => {
    setValue(option);
    if (getPoolValue) {
      getPoolValue(option);
    }
  };

  useEffect(() => {
    if (firstRender) return;
    setValue(currentValue);
  }, [currentValue]);

  useEffect(() => {
    if (!oldValue) return;
    if (!firstRender && oldValue.id === prevValue?.id) return;
    setValue(oldValue);
  }, [oldValue]);

  return {
    me,
    value,
    get needCleanup() {
      return value?.id !== initialValue?.id;
    },

    onSelect,
    onReset() {
      if (props.onClearClick) {
        props.onClearClick();
      } else {
        setValue(oldValue);
      }
    },
  };
};
